import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {IndexIasValueService} from '../../apiModule1';

export const indexIasResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: IndexIasValueService = inject(IndexIasValueService)) => {
  return service.apiIndexiasvalueGet({}, 'body', false, {transferCache: false});
};
